<template>
  <nav id="sidebar" class="d-none d-sm-block sidebar-menu" ref="sidebarContainer">
    <div class="sidebar-header">
      <!-- <router-link tag="h3" to="/">fragzone.gg</router-link>
      <router-link tag="strong" to="/">FZ</router-link>-->
      <b-navbar-brand to="/" exact v-b-tooltip.hover title="voltar a página inicial">
        <img src="../assets/logo.gif" class="small-logo" alt="QUEOTA.club">
        <img src="/img/queota-gradient.png" class="big-logo" alt="QUEOTA.club">
      </b-navbar-brand>
    </div>

    <ul class="list-unstyled components">
      <!-- class="active" -->
      <!--<b-nav-item to="/forum" class="forum-nav-link">
          Forum
          <b-badge class="forum-badge" v-if="currentUser && currentUser.forum_unread" v-b-tooltip.placement="'bottomright'" variant="primary" v-b-tooltip.hover title="novo post ou resposta, confira">&nbsp;</b-badge>
      </b-nav-item>-->

      <b-nav-item to="/teams">
        <i class="fas fa-users"></i>
        Times
      </b-nav-item>
      <b-nav-item to="/tournaments">
        <i class="fas fa-trophy"></i>
        Campeonatos
      </b-nav-item>
      <!--<b-nav-item to="/clubs">
        <i class="fas fa-place-of-worship"></i>
        Clubs
      </b-nav-item>
      <b-nav-item to="/practice" v-if="isLoggedIn">
        <i class="fas fa-chess"></i>
        Treinos
      </b-nav-item>
      <li class="nav-item">
        <a href="https://fightback.club/?utm_source=queotaclub"
          class="nav-link"
          target="_blank"
          v-b-tooltip.hover
          title="reveja suas partidas, aprenda táticas e melhore seu jogo - conheça nossa ferramenta, o FIGHTBACK"
        >
          <i class="fas fa-sort-amount-up"></i>
          Melhore
        </a>
      </li>-->

      <b-nav-item to="/loadout">
        <div class="w-icon">
          <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" xml:space="preserve" viewBox="0.77 0 83 40"><path d="M72.75 17.6a28.7 28.7 0 0 0-8.09-6.41c-2.32-1.28-4.77-2.45-7.4-2.96-1.68-.33-3.37-.77-5.08-.9l-3.62-.29-1.1-.08c-.05 0-.27-.63-.39-.78-.4-.5-1.96.02-2.57.1-.29.03-.7.58-.9.76-.59.52-1.33.86-2.05 1.14-1.96.76-4.34.95-6.44.77-.35-.04-.8-.13-1.15-.1-.18.02-.38.18-.55.16-.2-.01-.49-.22-.66-.3-.37-.17-.47-.27-.84-.18l-1.77.43a42 42 0 0 0-10.22 3.77c-.77.4-1.52.83-2.28 1.25-.13.07-.12.1-.16.26-.04.14-.25.19-.37.25-.3.15-.61.28-.8.56-.17.26-.31.46-.63.53-.6.14-.98.06-1.1.78-.09.52-.2.3-.52.3-.4-.01-1.07.07-1 .62-.13.36-.13.57-.5.67-.25.06-.5-.27-.77-.27-.3 0-.5.22-.6.48-.17.43-.1.77-.6.82-.31.03-1-.33-.9.32.1.88-1.27.5-1.57.94-.3.42-.44.9-.58 1.38-.12.44.03.47.34.81-.3.15-.78.27-.88.6l-.36 1.27-.79 2.75a9.25 9.25 0 0 1-1.1 2.4c-.18.3-.72.87-.75 1.21-.06.7 1.97.8 2.43.91.3.07.5.3.75.45l1.31.78c1.56.94 3.39 1.55 5.2 1.09a7.03 7.03 0 0 0 5.2-7.1c.32.25.5-.44.6-.62.36-.62.7-1.23 1.2-1.73 1.15-1.15 2.72-1 4.2-.88.42.03.47-.32.7-.64.45-.68.94-1.32 1.59-1.84a5.7 5.7 0 0 1 5.3-1c.64.2.64.32.94-.3a6.12 6.12 0 0 1 1.98-2.18 4.56 4.56 0 0 1 5.23.07c.83.6 1.53 1.47 2 2.38.2.37.44 1.62.94 1.7.39.07 2.06-.61 2.3-.9.35-.43-.2-.62.37-.85a38.75 38.75 0 0 1 5.32-1.45c2.61-.47 5.27-.6 7.92-.36 3.42.3 7 1.54 10.04 3.1 3.7 1.9 7.23 4.85 9.48 8.38-.24-2.07-1.18-4.14-2.13-5.98a32.29 32.29 0 0 0-4.12-6.1m-61.39 5.35c.81-.02 1.61-.11 2.4.16a5.29 5.29 0 0 1 3.09 3.5c.4 1.57.04 3.3-1.06 4.5a4.15 4.15 0 0 1-2.94 1.4c-1.11.1-1.83.03-2.85-.58a4.58 4.58 0 0 1-2.05-2.67 5.52 5.52 0 0 1 .13-3.54c.37-1.19 2-2.67 3.28-2.77"/><path fill="none" d="M83 0h84v40H83zM0 0h83v40H0z"/></svg>
        </div>
        Skins
      </b-nav-item>
      
      <b-nav-item to="/suporte">
        <i class="far fa-question-circle"></i>
        Suporte
      </b-nav-item>
      
      <b-nav-item
        v-if="isLoggedIn && currentUser && !currentUser.is_premium"
        to="/premium"
      >Seja Premium</b-nav-item>
    </ul>

    <ul class="list-unstyled CTAs">
      <li>
        <b-nav-item
          target="_blank"
          href="https://fightback.club?utm_source=queota-header"
          v-b-tooltip.hover
          title="reveja suas partidas, aprenda táticas e melhore seu jogo"
        >
          <!-- <i class="fas fa-hands-helping"></i> -->
          FIGHTBACK
        </b-nav-item>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  name: "SidebarMenu",
  props: {
    msg: String
  },
  data() {
    return {
      isCollapsed: true
    };
  },
  computed: {
  },
  methods: {
    toggleCollapse(event) {
      if (this.$refs.sidebarContainer.classList.contains("active")) {
        this.$refs.sidebarContainer.classList.remove("active");
        this.isCollapsed = false;
      } else {
        this.$refs.sidebarContainer.classList.add("active");
        this.isCollapsed = true;
      }
      this.$emit("collapse", this.isCollapsed);
    }
  },
  mounted() {
    this.toggleCollapse();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="sass">
.line
  width: 100%
  height: 1px
  border-bottom: 1px dashed #ddd
  margin: 10px 0

.w-icon
  width: 40px
  display: flex
  align-items: center
  justify-content: center
  margin: 0 auto
  margin-bottom: 10px

#sidebar
  min-width: 250px
  max-width: 250px
  background: #000
  color: #fff
  transition: all 0.3s
  .sidebar-header
    text-align: center
    padding: 5px 10px
    text-align: center
    position: relative
    .navbar-brand
      width: 100%
      text-align: center
      display: flex
      justify-content: center
    .big-logo
      display: block
      width: 140px
      height: 100%
    .small-logo
      display: none
      width: 32px
      height: 32px

  &.active
    min-width: 80px
    max-width: 80px
    text-align: center
    .sidebar-header .small-logo
      display: block
    .sidebar-header .big-logo, .CTAs
      display: none
  ul li a
    text-align: left
    // color: #7386D5
    color: #fff
  &.active
    ul
      li a
        padding: 20px 5px
        text-align: center
        font-size: 10px

        i
          margin-right: 0
          display: block
          font-size: 1.8em
          margin-bottom: 5px
      ul a
        padding: 10px !important
    .dropdown-toggle::after
      top: auto
      bottom: 10px
      right: 50%
      -webkit-transform: translateX(50%)
      -ms-transform: translateX(50%)
      transform: translateX(50%)
  
  ul
    &.components
      padding: 0 0 20px 0
      border-bottom: 1px solid #222
    li
      position: relative
      a
        padding: 10px
        font-size: 0.9em
        display: block
        &:hover
          // color: #7386D5
          color: #111
          background: #fff
          text-decoration: none
        i
          margin-right: 10px
      &.active > a
        color: #fff
        background: #6d7fcc

    .collapse.show
      background: #333

a
  &[aria-expanded="true"]
    color: #fff
    background: #6d7fcc
  &[data-toggle="collapse"]
    position: relative

.dropdown-toggle::after
  display: block
  position: absolute
  top: 50%
  right: 20px
  transform: translateY(-50%)

/* ---------------------------------------------------
 *    MEDIAQUERIES
 *-----------------------------------------------------

@media (max-width: 768px)
  #sidebar
    min-width: 80px
    max-width: 80px
    text-align: center
    margin-left: -80px !important
  .dropdown-toggle::after
    top: auto
    bottom: 10px
    right: 50%
    -webkit-transform: translateX(50%)
    -ms-transform: translateX(50%)
    transform: translateX(50%)
  #sidebar
    &.active
      margin-left: 0 !important
    .sidebar-header h3, .CTAs
      display: none
    .sidebar-header strong
      display: block
    ul
      li a
        padding: 20px 10px
        span
          font-size: 0.85em
        i
          margin-right: 0
          display: block
      ul a
        padding: 10px !important
      li a i
        font-size: 1.3em
    margin-left: 0
  #sidebarCollapse span
    display: none
</style>
